<template>
  <div class="app-container">
    <el-row>
      <el-col :sm="24" :xs="24">
        <el-card>
          <div class="card-body pt-6 mt-3">
            <clinic-coupons-tab />
            <clinic-coupons-filter />
            <clinic-coupons-button-group />
            <clinic-coupons-table />
            <pagination v-show="total>0" @pagination="fetchData" />
            <el-dialog :title="getTitle" :visible="clinicCouponVisible" :lock-scroll="false" @close="onCloseDialog()" :width="widthResize" top="10px" >
              <modal ref="clinicCouponModal"/>
            </el-dialog>
            <el-dialog :title="getTitleImport" :visible="csvVisible" :lock-scroll="false" @close="onCloseImportDialog()" :width="widthResize" top="10px" >
              <modal-import-csv ref="importCsv"/>
            </el-dialog>
            <el-dialog :title="getTitle" :visible="therapistsModalVisible" :lock-scroll="false" @close="closeTherapistDialog()" :width="widthResize" top="10px" >
              <therapists-modal ref="therapistsModal"/>
            </el-dialog>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import Modal from '../owner/clinic_coupons/Modal'
  import ModalImportCsv from '../owner/clinic_coupons/ModalImportCsv'
  import ClinicCouponsTable from '../owner/clinic_coupons/Table'
  import ClinicCouponsTab from '../owner/clinic_coupons/Tab'
  import ClinicCouponsFilter from '../owner/clinic_coupons/Filter'
  import ClinicCouponsButtonGroup from '../owner/clinic_coupons/ButtonGroup'
  import TherapistsModal from '../owner/clinic_coupons/TherapistsModal';
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  export default {
    data() {
      return {
        windowWidth: '',
      }
    },
    created() {
      window.addEventListener('resize', this.handleResize)
      this.handleResize()
    },
    components: {
      Modal,
      ModalImportCsv,
      ClinicCouponsTable,
      ClinicCouponsFilter,
      ClinicCouponsButtonGroup,
      TherapistsModal,
      ClinicCouponsTab,
    },
    computed: {
      widthResize() {
        return this.windowWidth > 768 ? '50%' : '95%'
      },
      ...mapGetters(['clinicCouponVisible', 'total', 'queryClinicCoupon', 'therapistsModalVisible', 'csvVisible']),
      getTitle() {
        return '回数券管理'
      },
      getTitleImport() {
        return 'CSVインポート'
      }
    },
    mounted() {
      this.fetchData()
    },
    methods: {
      ...mapActions('clinic_coupon', ['fetchClinicCoupons']),
      ...mapActions('clinic_customer_note', ['fetchClinicCustomerNotes']),
      ...mapMutations('clinic_coupon', ['SET_CLINIC_COUPON_VISIBLE', 'SET_THERAPISTS_MODAL_VISIBLE', 'SET_CSV_VISIBLE']),
      ...mapActions('clinic', ['fetchPointClinics', 'fetchCurrentClinic']),
      async fetchData() {
        await this.fetchCurrentClinic()
        this.fetchClinicCoupons()
      },
      handleResize() {
        this.windowWidth = window.innerWidth;
      },
      onCloseDialog() {
        this.$refs.clinicCouponModal.$refs['form'].resetFields()
        this.SET_CLINIC_COUPON_VISIBLE(false)
      },
      onCloseImportDialog() {
        this.$refs.importCsv.$refs['form'].resetFields()
        this.SET_CSV_VISIBLE(false)
      },
      closeTherapistDialog() {
        this.SET_THERAPISTS_MODAL_VISIBLE(false)
      }
    }
  }
</script>

<style>
div#vs2__combobox {
  height: 40px;
}
</style>
